import type {WorkWithExpressions} from 'services/metadata/types';
import {isWorkValue} from './isWorkValue';

export const isWorkWithExpressions = (
  value: unknown,
): value is WorkWithExpressions => {
  return isWorkValue(value) && !!(value as WorkWithExpressions).expressions;
};
